import React from 'react';
import { Container, Row, Card, Button } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';

function ArmonizacionContable() {
  return (
    <Container>
      <Row className="justify-content-center">
        <h1 className="text-center">Directorio de los módulos de atención</h1>
      </Row>
      <Row className="justify-content-center">
        <Accordion defaultActiveKey="0">
          <Accordion.Item eventKey="0">
            <Accordion.Header>Accordion Item #1</Accordion.Header>
            <Accordion.Body>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do

            <br></br><br></br>
              <Button variant="primary" href="../Pdf/ANEXO1.pdf" target="_blank">
                Descargar PDF
              </Button>
              <Button variant="success" href="../xls/ANEXO1.xls" target="_blank">
                Descargar Excel
              </Button>
            </Accordion.Body>
          </Accordion.Item>





          <Accordion.Item eventKey="1">
            <Accordion.Header>Accordion Item #2</Accordion.Header>
            <Accordion.Body>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              <br></br><br></br>
              <Button variant="primary" href="../Pdf/ANEXO1.pdf" target="_blank">
                Descargar PDF
              </Button>
              <Button variant="success" href="../xls/ANEXO1.xls" target="_blank">
                Descargar Excel
              </Button>
            </Accordion.Body>
          </Accordion.Item>














        </Accordion>
      </Row>
    </Container>
  );
}

export default ArmonizacionContable;
